var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikethrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 7.5H11.48L8.075 6.452c-.804-.248-1.306-1.047-1.181-1.879.125-.832.84-1.448 1.682-1.448h2.61c.738 0 1.413.417 1.744 1.077.154.309.53.434.838.28l1.677-.839c.309-.154.434-.53.28-.838l-.02-.04C14.857 1.072 13.124 0 11.23 0H8.575C7.213.001 5.915.577 5 1.586c-.915 1.009-1.362 2.357-1.23 3.712.078.816.394 1.556.85 2.202H.626C.28 7.5 0 7.78 0 8.125v1.25C0 9.72.28 10 .625 10h18.75c.345 0 .625-.28.625-.625v-1.25c0-.345-.28-.625-.625-.625zm-7.04 3.75c.49.307.79.845.79 1.424 0 .939-.762 1.7-1.701 1.701h-2.61c-.738 0-1.413-.417-1.744-1.077-.154-.309-.53-.434-.838-.28l-1.677.839c-.309.154-.434.53-.28.838l.02.04c.847 1.694 2.58 2.765 4.474 2.765h2.656c1.362-.001 2.66-.577 3.575-1.586.915-1.009 1.362-2.357 1.23-3.712-.035-.324-.104-.643-.209-.952h-3.687z",
    transform: "translate(2 3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough);
export default __webpack_public_path__ + "static/media/strikethrough.e69b48db594d2d3c2380377e0416e051.svg";
export { ForwardRef as ReactComponent };